import { memo } from 'react';
import { createPortal } from 'react-dom';
import { useAtomValue } from 'jotai/react';
import { contentTransformAtom } from '@user/pages/ViewModelPage/contentTransformAtom';
import { DescriptionPanel } from '@view-model/models/sticky/DescriptionPanel/domain/DescriptionPanel';

type Props = {
  position: { x: number; y: number } | null;
};

/**
 * 説明パネルのドラッグ中に表示するゴースト。
 * 実際の説明パネルのサイズを現在のズームスケールに合わせて描画する。
 */
const DescriptionPanelDragGhostFn: React.FC<Props> = ({ position }: Props) => {
  const contentTransform = useAtomValue(contentTransformAtom);

  if (!position) return null;

  const { width: canvasWidth, height: canvasHeight } = DescriptionPanel.DefaultSize;
  const scale = contentTransform.k;
  const screenWidth = canvasWidth * scale;
  const screenHeight = canvasHeight * scale;

  return createPortal(
    <div
      style={{
        position: 'fixed',
        left: position.x,
        top: position.y,
        width: screenWidth,
        height: screenHeight,
        boxSizing: 'border-box',
        transform: 'translate(-50%, -50%)',
        pointerEvents: 'none',
        zIndex: 9999,
        backgroundColor: '#FFFFFF',
        border: '2px solid #9CA3AF',
        borderRadius: 4,
        opacity: 0.6,
      }}
    />,
    document.body
  );
};

export const DescriptionPanelDragGhost = memo(DescriptionPanelDragGhostFn);
